<template>
  <div>
    <!-- <div class="register-section">
      <div class="columns">
        <div class="column is-12">
          <div class="columns">
            <div class="column is-half text-center">
              <img
                class="lazboy-logo"
                src="@/assets/beyound-the-recliner.png"
                alt="LA-Z Boy"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column is-half text-center">
              <h2 class="text-h6 text-lg-h6 title-color font-weight-light">
                Please join us for an exclusive event of
              </h2>
              <h1 class="font-weight-bold product-launching title-color">
                "NEW PRODUCT LAUNCHING"
              </h1>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half text-center display-1 text-h6">
              <h4 class="font-weight-bold">Live streaming at</h4>
              <a href="/live">
                <h4 class="font-weight-bold website-color">
                  www.lazboyasiaconf.com
                </h4>
              </a>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half text-center">
              <p class="date">
                <span class="font-weight-bold"
                  >January
                  <span class="display-2 text-h5 font-weight-bold"
                    >27<sup>th</sup></span
                  >, 2022</span
                >
                <br />
                <span class="time font-weight-normal"
                  >1.45 - 3.15 PM <span>(BKK Time)</span></span
                >
              </p>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half text-center">
              <div class="box-border">
                <countdown
                  :time="time"
                  :interval="100"
                  tag="div"
                  class="countdown-container"
                >
                  <template slot-scope="props">
                    <div class="d-flex justify-space-between">
                      <div class="d-block">
                        <span class="text-lg-h3 text-h5 font-weight-bold">{{
                          props.days > 1
                            ? props.days * 24
                            : props.days == 1
                            ? props.hours + 24
                            : props.hours
                        }}</span>
                        <div>Hours</div>
                      </div>
                      <span class="text-lg-h3 text-h6">:</span>
                      <div class="d-block">
                        <span class="text-lg-h3 text-h6 font-weight-bold">{{
                          props.minutes
                        }}</span>
                        <div>Minutes</div>
                      </div>
                      <span class="text-lg-h3 text-h6">:</span>
                      <div class="d-block">
                        <span class="text-lg-h3 text-h6 font-weight-bold">{{
                          props.seconds
                        }}</span>
                        <div>Seconds</div>
                      </div>
                    </div>
                  </template>
                </countdown>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half text-center">
              <router-link to="/register">
                <img
                  class="register-btn"
                  :src="require('@/assets/register2-btn.png')"
                  alt="register"
                />
              </router-link>
              <router-link to="/live">
                <img
                  class="register-btn"
                  :src="require('@/assets/join-btn.png')"
                  alt="register"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="columns">
        <div class="column is-12">
          <div class="relative">
            <v-img class="is-hidden-mobile" :src="require('@/assets/home/hq-2026.jpg')" alt="hq" />
            <v-img class="is-hidden-desktop" :src="require('@/assets/home/hq-2026-mobile.jpg')" alt="hq" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <h4 class="text-xs-h5 text-lg-h4 title-color pb-4">OUR MISSION</h4>
          <p>
            “La-Z-Boy enriches people’s lives by transforming houses into homes”
          </p>
          <p>
            Our mission is to be the leading global provider of comfortable,
            personalized and stylish home furnishings. Our people are passionate
            about our customers. Creating quality products and investing in
            their communities.
          </p>
        </div>
      </div>
      <div class="columns is-mobile is-multiline">
        <div class="column is-4-desktop is-half-mobile">
          <v-img :src="require('@/assets/home/2man.png')" alt="history" />
        </div>
        <div class="column is-4-desktop is-half-mobile">
          <v-img :src="require('@/assets/home/2man-2.png')" alt="history" />
        </div>
        <div class="column is-4-desktop is-12-mobile">
          <h4 class="text-xs-h5 text-lg-h4 title-color pb-4">
            HOW IT ALL BEGAN
          </h4>
          <p>
            It was 1927, in Monroe Detroit when two cousins (Edwin Shoemaker and
            Edward Knabusch) designed their first La-Z-Boy recliner. Until this
            date, no one had considered designing a chair that reclined…a
            simple, yet effective concept.
          </p>
          <p>
            At the time, the cousins constructed the chair entirely out of
            timber, with the mechanism allowing the chair to move forward, as
            you pushed the top part of the chair backwards. The chairs
            appearance represented something you would find on your deck or
            patio today and was designed to represent ‘nature's way of
            relaxing’.
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <v-img :src="require('@/assets/home/map.png')" alt="map" />
        </div>
      </div>
      <div>
        <h4 class="text-xs-h5 text-lg-h4 title-color pb-4">
          Campaign: Commercial Ad
        </h4>
      </div>
      <div class="columns is-mobile is-multiline">
        <div
          v-for="(video, index) in videoList"
          :key="index"
          class="column is-half-desktop is-full-mobile"
        >
          <video controls :src="video.src" v-bind="(video.poster || generatedPosters[index]) ? { poster: video.poster || generatedPosters[index] } : {}" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: "home",
  data() {
    return {
      time: new Date("2022-01-27 13:45:00 GMT+0700") - new Date(),
      generatedPosters: {},
      videoList: [
        {
          src: "/videos/8. La-Z-Boy_Well-Being Comm VDO_16_9.mp4",
          // poster: require("@/assets/home/k.png"),
        },
        {
          src: "/videos/7. La-Z-Boy_Specialty Covers.mp4",
        },
        {
          src: "/videos/6. La-Z-Boy_Power Glider.mov",
        },
        {
          src: "/videos/5. La-Z-Boy_Conserve Project.mp4",
        },
        {
          src: "/videos/4. La-Z-Boy_Pedestal Chair.mp4",
        },
        {
          src: "/videos/3. La-Z-Boy_All Black Series.mov",
        },
        {
          src: "/videos/2. La-Z-Boy_Kitten Commercial.mov",
        },
        {
          src: "/videos/1. La-Z-Boy_Beyond the Recliner Collection.mov",
        },
      ],
    };
  },
  mounted() {
    this.videoList.forEach((video, index) => {
      if (!video.poster) {
        this.captureVideoPoster(video.src, index);
      }
    });
  },
  async created() {
    const countdown = await this.$store.dispatch("getCountdown");
    this.time = new Date(countdown.target) - new Date(countdown.now);
  },
  methods: {
    captureVideoPoster(src, index) {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      video.preload = "metadata";
      video.muted = true;
      video.src = src;
      video.addEventListener(
        "loadedmetadata",
        () => {
          video.currentTime = Math.min(1, video.duration / 2);
        },
        { once: true }
      );
      video.addEventListener(
        "seeked",
        () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext("2d").drawImage(video, 0, 0);
          this.$set(this.generatedPosters, index, canvas.toDataURL());
          video.src = "";
        },
        { once: true }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
@media #{map-get($display-breakpoints, 'md-and-down')} {
  p,
  h4,
  h5 {
    padding: 8px;
  }
}

.hero-overlay-card {
  position: absolute;
  bottom: 28px;
  right: 32px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 12px;
  padding: 22px 28px;
  max-width: 320px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .hero-overlay-card {
    position: relative;
    margin-top: auto;
    padding: 2px;
  }
}
.hero-overlay-card h2 {
    font-size: 1.3rem;
    font-weight: 700;
    font-style: italic;
    color: #003349;
    margin-bottom: 10px;
}

.relative {
  position: relative;
}
</style>